import goalImage from "./assets/images/goal.png";
import simpleStep1 from "./assets/images/simple-step1.png";
import simpleStep2 from "./assets/images/simple-step2.png";
import simpleStep3 from "./assets/images/simple-step3.png";
import simpleStep4 from "./assets/images/simple-step4.png";
import personPoint from "./assets/images/person-point.png";
import handshake from "./assets/images/handshake.png";
import product1 from "./assets/images/product-1.png";
import product2 from "./assets/images/product-2.png";
import product3 from "./assets/images/product-3.png";
import product4 from "./assets/images/product-4.png";
import supportProgrammes from "./assets/images/support-programmes.png";
import donateImage from "./assets/images/donate-image.png";
import reelLogoGreen from "./assets/images/reel-logo-green.png";
import subscribeCTA from "./assets/images/subscribe-cta.png";
import envelopeImage from "./assets/images/envelope.png";
import pots from "./assets/images/pots.png";
import xsGardenBox from "./assets/images/products/xs-garden-box.png";
import smGardenBox from "./assets/images/products/sm-garden-box.png";
import mdGardenBox from "./assets/images/products/md-garden-box.png";
import lgGardenBox from "./assets/images/products/lg-garden-box.png";
import tomato from "./assets/images/products/tomato.png";
import beans from "./assets/images/products/beans.png";
import spinach from "./assets/images/products/spinach.png";
import carrot from "./assets/images/products/carrot.png";
import cabbage from "./assets/images/products/cabbage.png";
import cabbageCircle from "./assets/images/products/cabbage-circle.png";
import beetrootCircle from "./assets/images/products/beetroot-circle.png";
import carrotCircle from "./assets/images/products/carrot-circle.png";
import chilliCircle from "./assets/images/products/chilli-circle.png";
import herbCircle from "./assets/images/products/herb-circle.png";
import onionCircle from "./assets/images/products/onion-circle.png";
import pepperCircle from "./assets/images/products/pepper-circle.png";
import spinachCircle from "./assets/images/products/spinach-circle.png";
import tomatoCircle from "./assets/images/products/tomato-circle.png";
import { Facebook, Instagram, Linkedin } from "react-feather";
import ProductCard from "./components/ProductCard";
import LargeProductCard from "./components/LargeProductCard";
import companyBanner from "./assets/images/company_assets/webuycars/0689_WBC Mandela day garden project_Reel Gardening_Banner_1920 x 600px_V13.jpg";
import carousel1 from "./assets/images/company_assets/webuycars/carousel1.jpg";
import carousel2 from "./assets/images/company_assets/webuycars/carousel2.jpg";
import carousel3 from "./assets/images/company_assets/webuycars/carousel3.jpg";

function Collaborations() {
  return (
    <div className="overflow-hidden">
      <div className="relative h-full lg:h-[450px] 2xl:h-[550px] overflow-hidden">
        <img src={companyBanner} alt="" />
      </div>

      <div className="w-full flex flex-col lg:flex-row px-5 relative pt-12 pb-20 bg-slate-100">
        <div className="w-full lg:w-2/3 lg:ml-24 mb-8 lg:mb-0">
          <h1 className="text-2xl md:text-3xl lg:text-4xl text-gray-800 mb-6 lg:mb-9 leading-tight text-left font-semibold">
            Welcome to the WeBuyCars Garden in a Box Initiative
          </h1>

          <div className="space-y-4 lg:space-y-6">
            <p className="text-base md:text-lg leading-relaxed text-gray-700 text-justify">
              At WeBuyCars, we believe in growing more than just business – we
              grow purpose, connection, and sustainability. That’s why we’ve
              partnered with The Reel Organisation, a South African social
              enterprise that empowers communities through food security and
              urban agriculture.
            </p>

            <p className="text-base md:text-lg leading-relaxed text-gray-700 text-justify">
              Through this initiative, you can purchase your very own Garden in
              a Box – a compact, easy-to-use vegetable garden designed for home,
              balcony, or office use. As part of WeBuyCars’ commitment to
              contributing to projects that improve the quality of life in
              communities, we encourage staff members to buy any of the garden
              options available, either to own or to donate.
            </p>

            <p className="text-base md:text-lg leading-relaxed text-gray-700 text-justify">
              This project will run from Mandela Day on 18 July 2025 to World
              Food Day on 16 October 2025. All the gardens donated by WeBuyCars
              Head Office staff will be used to establish the community garden
              at Little Hearts Early Learning Centre in Kameeldrift and will be
              planted on World Food Day.
            </p>

            <p className="text-base md:text-lg leading-relaxed text-gray-700 text-justify">
              Our goal is for Head Office staff to jointly buy gardens worth a
              minimum of R15 000. For contributions of R15 000 and above,
              WeBuyCars will match the full amount raised by donating additional
              gardens.
            </p>

            <p className="text-base md:text-lg leading-relaxed text-gray-700 text-justify">
              Help us to provide the community with food and opportunity, making
              a lasting difference.
            </p>
          </div>
        </div>
        <div className="w-full lg:w-1/3 flex justify-center hidden">
          <div className="relative">
            <img src={goalImage} alt="Goal" className="w-60 md:w-80 h-auto" />
          </div>
        </div>
      </div>

      {/* Image Carousel */}
      <div className="w-full px-5 py-8 md:py-16 bg-white">
        <div className="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-8">
          <div className="flex-1 max-w-lg w-full">
            <img
              src={carousel1}
              alt="Brand 1"
              className="w-full h-48 md:h-80 object-cover rounded-lg shadow-md"
            />
          </div>
          <div className="flex-1 max-w-lg w-full">
            <img
              src={carousel2}
              alt="Brand 2"
              className="w-full h-48 md:h-80 object-cover rounded-lg shadow-md"
            />
          </div>
          <div className="flex-1 max-w-lg w-full">
            <img
              src={carousel3}
              alt="Brand 3"
              className="w-full h-48 md:h-80 object-cover rounded-lg shadow-md"
            />
          </div>
        </div>
      </div>

      {/* Planting Made Simple */}
      <div className="w-full px-5 py-8 bg-[radial-gradient(circle_at_0%_0%,#e0f0e5_0%,#749a8b_60%,#81bc00_100%)]">
        <div className="w-[95%] lg:w-[80%] mx-auto">
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-12 items-center">
            <div className="w-full lg:w-1/2">
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-dark-green mb-4 text-left drop-shadow-lg">
                PLANTING MADE SIMPLE
              </h2>
              <h3 className="text-xl md:text-2xl lg:text-3xl font-semibold text-dark-green mb-6 text-left drop-shadow-lg">
                WITH PATENTED REEL SEED TAPE
              </h3>
              <p className="text-base md:text-lg lg:text-xl leading-6 text-dark-green text-left font-semibold">
                Reel Gardening's patented seed tape takes the guesswork out of
                growing food. Each biodegradable strip is embedded with seeds
                and nutrients, spaced at the perfect depth and distance apart—so
                there's no need to measure, dig, or worry about what goes where.
                It's gardening made truly accessible for everyone, from
                first-time growers to seasoned planters. Just place, water, and
                grow. Every kit includes companion plants for healthier harvests
                and maximum yield.
              </p>
            </div>

            <div className="w-full lg:w-1/2">
              <div className="flex flex-col md:flex-row gap-4 md:gap-8">
                <div className="flex-1">
                  <img
                    src={simpleStep1}
                    alt="Step 1"
                    className="w-full h-32 md:h-48 object-contain"
                  />
                  <p className="text-sm md:text-base text-dark-green mt-2 text-center font-semibold">
                    Seed & Nutrients Inside the patented paper tape.
                  </p>
                </div>
                <div className="flex-1">
                  <img
                    src={simpleStep2}
                    alt="Step 2"
                    className="w-full h-32 md:h-48 object-contain"
                  />
                  <p className="text-sm md:text-base text-dark-green mt-2 text-center font-semibold">
                    Make a furrow in the soil and plant the seed tape
                    vertically.
                  </p>
                </div>
                <div className="flex-1">
                  <img
                    src={simpleStep3}
                    alt="Step 3"
                    className="w-full h-32 md:h-48 object-contain"
                  />
                  <p className="text-sm md:text-base text-dark-green mt-2 text-center font-semibold">
                    Water the seed
                    <br /> tape daily.
                  </p>
                </div>
                <div className="flex-1">
                  <img
                    src={simpleStep4}
                    alt="Step 4"
                    className="w-full h-32 md:h-48 object-contain"
                  />
                  <p className="text-sm md:text-base text-dark-green mt-2 text-center font-semibold">
                    Paper will decompose while keeping the plant protected and
                    moist as it grows.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Get Growing Layout Section */}
      <div className="w-full mt-8 mb-8">
        <div className="flex flex-col lg:flex-row">
          {/* Left Column - Single Div */}
          <div className="w-full lg:w-1/2">
            <div className="p-6 h-full min-h-[400px] lg:min-h-[750px] bg-[radial-gradient(at_0%_0%,#759b8b_0%,#b2cc6c_90%,#81bc00_100%)]">
              <div className="flex flex-col items-center h-full relative">
                <div className="text-center">
                  <h3
                    className="text-4xl md:text-6xl lg:text-9xl font-bold text-white tracking-wider"
                    style={{ fontFamily: "bebas-neue, sans-serif" }}
                  >
                    GET GROWING
                  </h3>
                  <h4
                    className="text-2xl md:text-4xl lg:text-6xl -mt-2 text-white text-right tracking-wider"
                    style={{ fontFamily: "bebas-neue, sans-serif" }}
                  >
                    BY GIVING
                  </h4>
                </div>
                <img
                  src={personPoint}
                  alt="point"
                  className="absolute top-12 lg:top-auto lg:-bottom-3 left-1/3 transform -translate-x-1/2 w-auto h-[70%] lg:h-[90%] min-h-[300px] lg:min-h-[600px]"
                />
              </div>
            </div>
          </div>

          {/* Right Column - 3 Rows */}
          <div className="w-full lg:w-1/2 flex flex-col">
            {/* Top Row - 2 Columns */}
            <div className="flex flex-col md:flex-row relative">
              <div className="w-full md:w-1/2 bg-[#8ebf69] p-4 py-8 flex flex-col justify-between">
                <div>
                  <h4 className="text-xl md:text-2xl lg:text-3xl font-semibold text-white md:mr-16 mb-2 text-left">
                    ORDER YOUR GARDEN IN A BOX
                  </h4>
                  <p className="text-base md:text-lg lg:text-2xl font-medium text-white text-left md:mr-16">
                    Choose from curated kits designed for urban and suburban
                    lifestyles. Includes patented seed tape, planting guide,
                    nutrients, and more.
                  </p>
                </div>
                <button
                  className="w-full md:w-2/3 mx-auto bg-[#248c52] border-2 border-[#248c52] shadow-xl text-white font-semibold py-3 px-6 rounded-full hover:bg-[#82bc00] hover:border-[#82bc00] transition-colors duration-200 mt-4"
                  onClick={() =>
                    window.open(
                      "https://store.reel.org.za/collections/all",
                      "_blank"
                    )
                  }
                >
                  GET MY GARDEN IN A BOX
                </button>
              </div>
              <div className="w-full md:w-1/2 bg-[#248c52] p-4 py-8 flex flex-col justify-between">
                <div>
                  <h4 className="text-xl md:text-2xl lg:text-3xl font-semibold text-white lg:ml-20 mb-2 text-left">
                    WE MATCH YOUR IMPACT
                  </h4>
                  <p className="text-base md:text-lg lg:text-2xl font-medium text-white text-left lg:ml-20">
                    For every garden you purchase, one is donated to a community
                    in need via The Reel Organisation.
                  </p>
                </div>
                <button
                  className="w-full md:w-2/3 mx-auto bg-[#8ebf69] border-2 border-[#8ebf69] shadow-xl text-white font-semibold py-3 px-6 rounded-full hover:bg-[#82bc00] hover:border-[#82bc00] transition-colors duration-200 mt-4"
                  onClick={() =>
                    window.open(
                      "https://reelgardening.co.za/social-impact/",
                      "_blank"
                    )
                  }
                >
                  SEE COMMUNITY IMPACT
                </button>
              </div>
              <img
                src={handshake}
                alt="handshake"
                className="hidden md:block absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-auto h-32 lg:h-48 z-10"
              />
            </div>

            {/* Middle Row - 2 Columns */}
            <div className="bg-[#6bad83] p-4 w-full flex flex-col lg:flex-row">
              <div className="w-full lg:w-2/3">
                <h4 className="text-xl md:text-2xl lg:text-3xl font-semibold text-white mb-2 text-left">
                  LEARN AS YOU GROW
                </h4>
                <p className="text-base md:text-lg lg:text-2xl font-medium text-white text-left">
                  As part of this programme, you'll gain exclusive access to our
                  <br />
                  Online Learning Hub, where you can:
                </p>
                <ul className="text-base md:text-lg lg:text-2xl font-medium text-white text-left mt-4 space-y-2">
                  <li className="flex items-start">
                    <span className="text-white mr-3">•</span>
                    Learn to plant and care for your own vegetables.
                  </li>
                  <li className="flex items-start">
                    <span className="text-white mr-3">•</span>
                    Explore the social impact of food security and
                    sustainability.
                  </li>
                  <li className="flex items-start">
                    <span className="text-white mr-3">•</span>
                    Join interactive workshops and webinars with The Reel
                    Organisation's expert trainers.
                  </li>
                </ul>
              </div>
              <div className="w-full lg:w-1/3 flex items-center justify-center mt-4 lg:mt-0">
                <button
                  className="bg-[#6bad83] border-2 border-[#6bad83] shadow-xl text-white font-semibold py-3 px-6 rounded-full hover:bg-[#769b8b] hover:border-[#769b8b] transition-colors duration-200"
                  onClick={() =>
                    window.open(
                      "https://reelgardening.co.za/resources/",
                      "_blank"
                    )
                  }
                >
                  EXPLORE RESOURCES
                </button>
              </div>
            </div>

            {/* Bottom Row - Standard */}
            <div className="bg-[#769b8b] p-4 w-full flex flex-col lg:flex-row">
              <div className="w-full lg:w-3/5">
                <h4 className="text-2xl md:text-3xl lg:text-5xl font-semibold text-white mb-2 text-left">
                  A GARDEN IN A BOX,
                  <br /> CURATED FOR YOU.
                </h4>
                <p className="text-base md:text-lg lg:text-2xl font-medium text-white text-left">
                  You don't need green fingers to grow your own food. Our Garden
                  in a Box gives you everything you need to get started- no
                  matter your space or experience. Whether you're a teacher
                  planting with learners, a parent growing at home, or a budding
                  urban farmer, our kits make it easy. Just add water.
                </p>
              </div>
              <div className="w-full lg:w-2/5 flex items-center justify-center mt-4 lg:mt-0">
                <div className="grid grid-cols-2 gap-4 lg:gap-8">
                  <img
                    src={product1}
                    alt="Product 1"
                    className="w-20 md:w-24 lg:w-32 h-20 md:h-24 lg:h-32 object-cover rounded-lg"
                  />
                  <img
                    src={product2}
                    alt="Product 2"
                    className="w-20 md:w-24 lg:w-32 h-20 md:h-24 lg:h-32 object-cover rounded-lg"
                  />
                  <img
                    src={product3}
                    alt="Product 3"
                    className="w-20 md:w-24 lg:w-32 h-20 md:h-24 lg:h-32 object-cover rounded-lg"
                  />
                  <img
                    src={product4}
                    alt="Product 4"
                    className="w-20 md:w-24 lg:w-32 h-20 md:h-24 lg:h-32 object-cover rounded-lg"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Products Section */}
      <div className="w-full px-5 py-8 md:py-16 bg-white relative space-y-8 hidden lg:block">
        <div className="w-[95%] 2xl:w-[85%] mx-auto">
          <ProductCard
            productImage={xsGardenBox}
            productName="X-Small Garden in a Box"
            vegetables="Tomato, Beans & Spinach"
            seedTapes="3 SEED TAPES OF EACH VARIETAL"
            totalPlants="9 PLANTS TOTAL"
            plantsCount="3 POTS"
            plantsIcon={pots}
            description="Perfect for a windowsill"
            vegetableImages={[
              { src: tomato, alt: "Tomato" },
              { src: beans, alt: "Beans" },
              { src: spinach, alt: "Spinach" },
            ]}
            price="20.00"
            onProductClick={() =>
              window.open(
                "https://store.reel.org.za/products/x-small-garden-in-a-box",
                "_blank"
              )
            }
          />
        </div>
        <div className="w-[95%] 2xl:w-[85%] mx-auto">
          <ProductCard
            productImage={smGardenBox}
            productName="Small Garden in a Box"
            vegetables="Carrot, Cabbage, Spinach & tomato"
            seedTapes="3 SEED TAPES OF EACH VARIETAL"
            totalPlants="12 PLANTS TOTAL"
            plantsCount="1 SQM"
            description="perfect for 1 person"
            vegetableImages={[
              { src: tomato, alt: "Tomato" },
              { src: cabbage, alt: "Cabbage" },
              { src: carrot, alt: "Carrot" },
              { src: spinach, alt: "Spinach" },
            ]}
            price="40.00"
            onProductClick={() =>
              window.open(
                "https://store.reel.org.za/products/small-garden-in-a-box",
                "_blank"
              )
            }
          />
        </div>
        <div className="w-[95%] 2xl:w-[85%] mx-auto">
          <LargeProductCard
            productImage={mdGardenBox}
            productName="Medium Garden in a Box"
            vegetables="Onion, marog, beetroot, tomato, spinach, green pepper & carrot"
            seedTapes="15 seed tapes of each varietal"
            totalPlants="120 plants in total"
            extras="Fertiliser sticks & Watering spout included"
            plantsCount="8 SQM"
            description="perfect for 2 people"
            vegetableImages={[
              { src: tomatoCircle, alt: "Tomato" },
              { src: cabbageCircle, alt: "Cabbage" },
              { src: pepperCircle, alt: "Pepper" },
              { src: carrotCircle, alt: "Carrot" },
              { src: onionCircle, alt: "Onion" },
              { src: beetrootCircle, alt: "Beetroot" },
              { src: spinachCircle, alt: "Spinach" },
            ]}
            price="90.00"
            onProductClick={() =>
              window.open(
                "https://store.reel.org.za/products/medium-garden-in-a-box",
                "_blank"
              )
            }
            detailsFloatRight={true}
          />
        </div>
        <div className="w-[95%] 2xl:w-[85%] mx-auto">
          <LargeProductCard
            productImage={lgGardenBox}
            productName="Large Garden in a Box"
            vegetables="tomato, spinach, green pepper, Cabbage, Onion, marog, beetroot, Carrot, Beans, Peas, chilli & herbs."
            seedTapes="60 seed tapes of each varietal"
            totalPlants="720 plants in total"
            extras="Fertiliser sticks & Watering spout included"
            plantsCount="48 SQM"
            plantCountExtras={[
              "4 sqm per month each month of the year.",
              "16sqm of land needed in total.",
            ]}
            description="perfect for 4 people"
            vegetableImages={[
              { src: tomatoCircle, alt: "Tomato" },
              { src: cabbageCircle, alt: "Cabbage" },
              { src: pepperCircle, alt: "Pepper" },
              { src: carrotCircle, alt: "Carrot" },
              { src: onionCircle, alt: "Onion" },
              { src: beetrootCircle, alt: "Beetroot" },
              { src: spinachCircle, alt: "Spinach" },
              { src: chilliCircle, alt: "Chilli" },
              { src: herbCircle, alt: "Herbs" },
            ]}
            price="450.00"
            onProductClick={() =>
              window.open(
                "https://store.reel.org.za/products/large-garden-in-a-box",
                "_blank"
              )
            }
            detailsFloatRight={true}
          />
        </div>
      </div>

      {/* Support Programmes Section */}
      <div className="w-full px-5 pt-8 md:pt-16 bg-white relative">
        <div className="w-[95%] mx-auto pb-20">
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-[#82bc00] mb-4">
            THE REEL PROGRAMME WHICH YOUR BOXES WILL SUPPORT:
          </h2>
          <p className="text-base md:text-lg text-gray-600 mb-8 md:mb-12 w-full md:w-[70%]">
            Currently, nearly half of South African households face monthly food
            shortages, and over 35% struggle to meet basic nutritional needs.
            Alarmingly, one in four children suffers from malnutrition,
            significantly compromising their long-term potential. As climate
            change and socio-economic pressures intensify, disadvantaged
            households require sustainable, adaptive solutions to achieve
            lasting food security and economic independence.
          </p>

          <div className="flex flex-col lg:flex-row gap-8 items-start">
            <div className="w-full lg:w-1/2">
              <p className="text-base md:text-lg leading-relaxed text-gray-700">
                Reel's integrated three-phase model uniquely addresses this
                challenge. Beginning with school-based gardens as educational
                hubs, Reel educates and engages communities through
                CAPS-accredited learning resources. The programme expands into
                household-level interventions, empowering families with patented
                Garden in a Box kits, providing them with simple, water-wise
                solutions to grow food year-round. Finally, committed households
                transition into agri-businesses, receiving specialised
                entrepreneurial training to sustainably generate income within
                the green economy.
              </p>
            </div>
            <div className="w-full lg:w-1/2">
              {/* Empty space for text layout */}
            </div>
          </div>
        </div>

        {/* Absolutely positioned image that can overlap multiple sections */}
        <div className="absolute -right-5 bottom-0 -mb-1 z-10 hidden lg:block">
          <img
            src={supportProgrammes}
            alt="Support Programmes"
            className="w-auto h-[400px] lg:h-[450px]"
          />
        </div>
      </div>

      {/* Donate CTA Section */}
      <div className="w-full bg-[#bad36c] relative z-20">
        <div className="max-w-7xl mx-auto px-5">
          <div className="flex flex-col lg:flex-row gap-8 items-center py-8 lg:py-0">
            <div className="w-full lg:w-1/2 flex justify-center">
              <img
                src={donateImage}
                alt="Donate to support communities"
                className="w-full h-auto max-w-md lg:max-w-none"
              />
            </div>
            <div className="w-full lg:w-1/2 text-center lg:text-left">
              <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-white mb-6 leading-tight">
                GROW FOOD. GROW FUTURES
              </h2>
              <p className="text-base md:text-lg lg:text-xl text-black mb-8 leading-relaxed">
                Empowering communities through sustainable gardening, education,
                and income generation. Join us in growing food security from the
                ground up.
              </p>
              <button
                className="bg-[#82bc00] border-2 border-[#82bc00] shadow-xl text-white font-semibold py-2 px-8 rounded-full hover:bg-[#248c52] hover:border-[#248c52] transition-colors duration-200 text-base md:text-lg"
                onClick={() =>
                  window.open(
                    "https://reelgardening.co.za/product/household-food-garden/",
                    "_blank"
                  )
                }
              >
                Donate Now
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Contact Information Section */}
      <div className="w-full bg-white py-8 px-5 relative z-30">
        {/* Keep in Touch CTA */}
        <div
          className="hidden lg:block absolute -right-10 w-2/5 h-52 bg-cover bg-left bg-no-repeat rounded-lg 2xl:rounded-md z-20 bg-transparent border-[#82bc00] 2xl:border-4 2xl:border-l-2"
          style={{ backgroundImage: `url(${subscribeCTA})` }}
        >
          <div className="flex flex-col justify-center items-start h-full p-6">
            <img
              src={envelopeImage}
              alt="Envelope"
              className="w-12 h-12 mb-3"
            />
            <h3
              className="text-3xl font-bold text-white tracking-wider mb-3 [text-shadow:_1px_1px_0_#016539,_-1px_1px_0_#016539,_1px_-1px_0_#016539,_-1px_-1px_0_#016539]"
              style={{ fontFamily: "bebas-neue, sans-serif" }}
            >
              LETS KEEP IN TOUCH
            </h3>
            <button
              className="bg-[#82bc00] border-2 border-[#82bc00] shadow-xl text-white font-semibold py-2 px-6 rounded-full hover:bg-[#82bc00] hover:border-[#82bc00] transition-colors duration-200"
              onClick={() =>
                window.open("https://reelgardening.co.za/contact-us/", "_blank")
              }
            >
              Subscribe
            </button>
          </div>
        </div>

        {/* Mobile Subscribe CTA */}
        <div className="lg:hidden text-center">
          <div className="bg-[#82bc00] rounded-lg p-6">
            <img
              src={envelopeImage}
              alt="Envelope"
              className="w-12 h-12 mx-auto mb-3"
            />
            <h3
              className="text-2xl font-bold text-white tracking-wider mb-3"
              style={{ fontFamily: "bebas-neue, sans-serif" }}
            >
              LETS KEEP IN TOUCH
            </h3>
            <button
              className="bg-white border-2 border-white shadow-xl text-[#82bc00] font-semibold py-2 px-6 rounded-full hover:bg-gray-100 hover:border-gray-100 transition-colors duration-200"
              onClick={() =>
                window.open("https://reelgardening.co.za/contact-us/", "_blank")
              }
            >
              Subscribe
            </button>
          </div>
        </div>

        <div className="w-[95%] lg:w-[80%] mx-auto">
          <div className="flex flex-col lg:flex-row gap-8 lg:gap-8 items-stretch">
            {/* Logo Column */}
            <div className="lg:absolute lg:top-0 lg:-mb-1 lg:z-10 text-center lg:text-left">
              <img
                src={reelLogoGreen}
                alt="Reel Organisation Logo"
                className="w-32 md:w-48 h-auto mx-auto lg:mx-0"
              />
            </div>

            <div className="w-full lg:w-1/3 flex flex-col justify-end">
              <div className="flex justify-center lg:justify-start gap-4 mb-4 lg:mb-4 hidden">
                <a
                  href="#"
                  className="bg-[#bad36c] hover:bg-[#82bc00] text-white rounded-full p-3 transition-colors duration-200"
                >
                  <Facebook size={24} />
                </a>
                <a
                  href="#"
                  className="bg-[#bad36c] hover:bg-[#82bc00] text-white rounded-full p-3 transition-colors duration-200"
                >
                  <Instagram size={24} />
                </a>
                <a
                  href="#"
                  className="bg-[#bad36c] hover:bg-[#82bc00] text-white rounded-full p-3 transition-colors duration-200"
                >
                  <Linkedin size={24} />
                </a>
              </div>
            </div>

            {/* Contact Information Column */}
            <div className="w-full lg:w-1/3 text-center lg:text-left">
              <h3 className="text-xl lg:text-2xl font-bold text-[#248c52] mb-6">
                Get In Touch
              </h3>
              <div className="space-y-4">
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2">Address:</h4>
                  <p className="text-sm lg:text-base text-gray-600">
                    Reel Organisation
                    <br />
                    Unit 8, Ferngate Business Park
                    <br />
                    411 Long Avenue
                    <br />
                    Ferndale, Randburg
                    <br />
                    South Africa
                    <br />
                    2194
                  </p>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2">Phone:</h4>
                  <a
                    href="tel:+27117820661"
                    className="text-sm lg:text-base text-gray-600 hover:text-[#248c52] transition-colors duration-200"
                  >
                    +27 11 782 0661
                  </a>
                </div>
                <div>
                  <h4 className="font-semibold text-gray-800 mb-2">Email:</h4>
                  <a
                    href="mailto:info@reel.org.za"
                    className="text-sm lg:text-base text-gray-600 hover:text-[#248c52] transition-colors duration-200"
                  >
                    info@reel.org.za
                  </a>
                </div>
              </div>
            </div>

            <div className="w-full lg:w-1/3 flex flex-col justify-end">
              <h4 className="text-black text-bold text-base lg:text-lg text-center lg:text-end">
                Reel. All Rights Reserved.
              </h4>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Collaborations;
